var $ = require('jquery')
  , detector = require('widgets/detector.js')
  , urlUtils = require('@173js/url')
  , GetDownloadUrls = require('widgets/getDownloadUrls')

$(function() {
  var urlParams = urlUtils.getURLParameters(window.location.search)
  var getDownloadUrls = new GetDownloadUrls()

  if (detector.isAndroid() && detector.isWexinQQBrowser()) {
    $('.weixin-tip').show()
    return
  } else {
    // 小米手机浏览器把自动下载禁掉了，提供一个手动下载的按扭
    var html = '<a id="btn" href="javascript:;" style="position:absolute;left:50%;top:45%;width:8em;font:700 20px/3 -apple-system;color:#000;text-align:center;text-decoration:none;background:#ffcd00;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border-radius:10px">点击下载</a>'
    $('body').append(html)
  }

  function toDownload(url, ssid){
    if(window.ued && window.ued.pingjs){
      window._jc_ping = window._jc_ping || [];
      _jc_ping.push([ 'go', url, {
        ssid: ssid
      }]);
    }
  }

  $.when(getDownloadUrls.getPlatformUrl(urlParams.code)).then(function(res) {
    var url = res.data
      , ssid = urlParams.ssid

    // 自动下载
    toDownload(url, ssid)

    $('body').on('click', '#btn', function(e) {
      toDownload(url, ssid)
    })
    // else{
    //   window.location = '//shaomatongji.17173.com/pv?url='
    //   + url
    //   + '&ssid2='
    //   + ssid;
    // }

    // window.location = url
  })

})